import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { action } from 'satcheljs/lib/legacy';
import { getAccountScopeUserConfiguration } from 'mini-common-utils/lib/utils/getAccountScopeUserConfiguration';
import { updateAccountScopeUserSettings } from 'owa-session-store';
export type ListViewBitFlagsMasks = any;

/**
 * Gets a boolean to indicate if the n th bit is 1
 * @param bitMask represents the nth bit
 * @return true if nth bit is 1, false if 0
 */
export function getIsBitSet(bitMask: ListViewBitFlagsMasks): boolean {
    const listViewBitFlags =
        getAccountScopeUserConfiguration().ViewStateConfiguration.ListViewBitFlags;
    return !!(bitMask & listViewBitFlags);
}

/**
 * Set bit flag
 * @param value set to 1 if true, 0 otherwise
 * @param bitMask represents the nth bit
 */
export const setBit = action('setBit')(function setBit(
    value: boolean,
    bitMask: ListViewBitFlagsMasks
) {
    // Already same value, no need to set again and update user config
    if (getIsBitSet(bitMask) === value) {
        return;
    }
    updateAccountScopeUserSettings(getUserMailboxInfo(), userConfig => {
        if (value) {
            // Set the bit to 1
            userConfig.ViewStateConfiguration.ListViewBitFlags |= bitMask;
        } else {
            // Clear the bit to 0
            userConfig.ViewStateConfiguration.ListViewBitFlags &= ~bitMask;
        }
    });
});
